module.exports = __webpack_public_path__ + "static/media/left_ailgn_02.37693b5f.jpeg";